import HomeDashboard from '../features/home/HomeDashboard'

/**
 * Anasayfa (landing) — kök yol (`/`). Uygulama ilk açılışta, ev ikonuna ve logoya tıklandığında buraya
 * gelir. İçerik **salt-okuma** iki panodur (068 / analiz): **Yönetici Raporu** (7 KPI, durum dağılımı,
 * kişi bazlı yük, kritik/geciken tablosu) ve **Raporum** (kendi aksiyon yükü, delegasyon, termin
 * dağılımı). Aktif pano `?view=manager|my` ile URL'de korunur; rota ve sol menü **değişmedi**.
 */
export default function HomePage() {
  return <HomeDashboard />
}
